import * as z from "zod";

export const UploadWeightReportSchema = z.object({
  document: z.string({
    required_error: "required",
    invalid_type_error: "required",
  }),
  senderCompanyId: z.number({
    required_error: "required",
    invalid_type_error: "required",
  }),
  externalId: z.any().default(null), // deprecated
  customerId: z.number({
    required_error: "required",
    invalid_type_error: "required",
  }),
  fileType: z.string({
    required_error: "required",
    invalid_type_error: "required",
  }),
  documentType: z.string({
    required_error: "required",
    invalid_type_error: "required",
  }),
  documentTitle: z.string({
    required_error: "required",
    invalid_type_error: "required",
  }),
  languageId: z.number({
    required_error: "required",
    invalid_type_error: "required",
  }),
  tiltedScan: z.boolean({
    required_error: "required",
    invalid_type_error: "required",
  }),
});

export type UploadWeightReportFormInput = z.infer<typeof UploadWeightReportSchema>;
